import { Box, Grid, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { getMyTrips } from "../../../api/group";
import { getGroupTrips } from "../../../api/jahadgar";
import GroupTableOnline from "./groupTableOnline";

export default function AddDrugInAreaPop({
  dataDrugSelect,
  equipment,
  notGroup,
}) {
  const [dataGroups, setDataGroups] = useState();

  useEffect(() => {
    if (notGroup) {
      getGroupTrips("?tripStatus=IN_PROGRESS")
        .then((x) =>
          setDataGroups(x.map((item) => ({ ...item, neededCount: 0 }))),
        )
        .catch((z) => console.log(z));
    } else {
      getMyTrips("?status=IN_PROGRESS&pageIndex=0&pageSize=100")
        .then((x) =>
          setDataGroups(x.content.map((item) => ({ ...item, neededCount: 0 }))),
        )
        .catch((z) => console.log(z));
    }
  }, [notGroup]);

  return (
    <>
      <Grid display="flex" flexDirection={"column"} width={"100%"} gap="20px">
        <Typography fontSize={"18px"} fontWeight="bold">
          گروه‌هایی که در هفته آینده اردو برگذار میکنند
        </Typography>
        <Box
          boxShadow="0px 4px 4px 0px #00000040"
          borderRadius={"9px"}
          bgcolor="#F5F9FF"
        >
          {dataGroups && (
            <GroupTableOnline
              dataDrugSelect={dataDrugSelect}
              setRowData={setDataGroups}
              rowData={dataGroups}
              equipment={equipment}
              notGroup={notGroup}
            />
          )}
        </Box>
      </Grid>
    </>
  );
}
